export function getSize(parts: readonly Uint8Array[]): number
{
    let size = 0;

    for (const bytes of parts)
    {
        size += bytes.byteLength;
    }

    return size;
}

export function flatten(parts: readonly Uint8Array[]): Uint8Array
{
    if (parts.length === 1)
    {
        return parts[0];
    }

    const result = new Uint8Array(getSize(parts));
    let offset = 0;

    for (const bytes of parts)
    {
        result.set(bytes, offset);
        offset += bytes.byteLength;
    }

    return result;
}

export function numberToBytes(
    value: number,
    bytesNumber: 1 | 2 | 4,
): Uint8Array
{
    const bytes = new Uint8Array(bytesNumber);
    const view = new DataView(bytes.buffer);
    let setBytes: (byteOffset: number, value: number) => void;

    switch (bytesNumber)
    {
        case 1:
            setBytes = view.setUint8.bind(view);
            break;
        case 2:
            setBytes = view.setUint16.bind(view);
            break;
        case 4:
            setBytes = view.setUint32.bind(view);
            break;
        default:
            throw new Error(`Number of bytes ${bytesNumber} is not supported`);
    }
    setBytes(0, value);

    return bytes;
}

export function byteChunksToInt(byteChunks: Uint8Array[])
{
    let value = 0;

    for (const byteChunk of byteChunks)
    {
        for (const byte of byteChunk)
        {
            value = (value << 8) + byte;
        }
    }

    return value;
}

export function splitChunks(
    byteChunks: Uint8Array[],
    bytesNumber: number,
): [Uint8Array[], Uint8Array[]]
{
    if (bytesNumber < 0)
    {
        throw new Error(`Invalid size ${bytesNumber} to slice`);
    }

    if (bytesNumber === 0)
    {
        return [[], byteChunks.slice()];
    }

    const head: Uint8Array[] = [];
    const tail: Uint8Array[] = [];

    let filledBytes = 0;
    let isFilled = false;

    for (const part of byteChunks)
    {
        if (isFilled)
        {
            tail.push(part);
        }
        else
        {
            const remainedToFill = bytesNumber - filledBytes;

            if (part.byteLength >= remainedToFill)
            {
                head.push(part.subarray(0, remainedToFill));
                tail.push(part.subarray(remainedToFill));
                isFilled = true;
            }
            else
            {
                head.push(part);
            }
        }

        filledBytes += part.byteLength;
    }

    if (!isFilled)
    {
        throw new Error(`Buffer is too small to slice ${bytesNumber} bytes`);
    }

    return [head, tail];
}
